<template>
	<div class="subject-test-performance">
		<div class="sub-test-test-cont">
			<div class="subTest-title">
				<span>一分三率分析</span>
				<div>
					<el-select v-model="newSubject" size="mini" placeholder="选择学科" @change="chageSelect">
						<el-option v-for="item in subjectData" :key="item.pkId" :label="item.subName" :value="item.pkId"> </el-option>
					</el-select>
				</div>
			</div>
			<div class="subTest-view">
				<div class="class-level-cont">
					<div class="class-level">
						<div>
							<span>平均分、优秀率、及格率、低分率等分析</span>
						</div>
					</div>
					<div class="class-level-table"></div>
					<div class="class-level-table"><tables :tableOptions="newTableData"></tables></div>
				</div>
				<!-- <div class="class-subject-level-cont">
					<div class="classSubject-desc">
						<p>各班级学科平均水平贡献率</p>
						<p>
							各班级的平均得分率看起来有高有低，与各班级各自实际客观情况有极大的关系（比如有示范班级与普通班级之分），
							不能简单通过排队来评价班级教学质量的高低，需要给予客观分析。
							相对于各班级自身综合水平而言，存在学科表现的非均衡性。我们基于班级实际的综合水平表现来考察某学科对班级学科综合水平的贡献，
							并联系考试总体的对应情况进行综合分析，提炼出体现学业水平的“学科贡献率”指标。
							一个班级的“学科贡献率”有正值或者负值。正值数值越大越好，是促进班级提高了综合水平的学科；负值的绝对值越大越不好，应是拖了后腿的学科。
						</p>
					</div>
					<div class="classSubject-btn">
						<el-button type="primary" size="mini">下载表格</el-button>
					</div>
					<div class="classSubject-table">
						<el-table :data="classSubject" border style="width: 100%" size="mini">
							<el-table-column prop="class" label="班级" width="70"> </el-table-column>
							<el-table-column sortable prop="secondGearNum" label="英语"> </el-table-column>
						</el-table>
					</div>
				</div> -->
				<!-- <div class="subject-grade-rate">
					<div class="subGra-title">
						<div class="grade-title">
							<span>各学科成绩等级结构比例（得分率）</span>
							<el-button type="info" size="mini" icon="el-icon-setting" @click="dialogVisible = true">设置等级参数</el-button>
						</div>
						<el-button type="info" size="mini">下载表格</el-button>
					</div>
					<div class="setting-level">
						<el-dialog title="设置等级参数" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
							<span style="padding-right: 10px">考试总分为100，将总体分为 </span>
							<span
								><el-radio-group v-model="radio" @change="selectLevel">
									<el-radio :label="index + 1" v-for="(item, index) in levelArr" :key="index">{{ item }}</el-radio>
									<el-radio :label="2">二等</el-radio>
									<el-radio :label="3">三等</el-radio>
								</el-radio-group></span
							>
							<el-form label-width="100px" class="demo-ruleForm">
								<el-form-item :label="item.level + '等:'" prop="" v-for="(item, index) in levelConts" :key="index">
									<div class="level-grade">
										<el-input
											type="number"
											class="gradeInpt"
											v-model="item.value"
											size="mini"
											@input="inputGrade(item)"
											@blur="blurGrade(item)"
										>
											<template slot="append">%</template>
										</el-input>
										<span
											>表示在总分*<span>{{ item.value }}</span
											>%的分数以上学生为<span>{{ item.level }}</span> 等</span
										>
										<p class="first-p1" v-show="item.error1">百分比必须大于0且小于100</p>
										<p class="first-p1" v-show="item.error2">高等级百分比必须大于低等级百分比</p>
									</div>
								</el-form-item>
							</el-form>
							<span slot="footer" class="dialog-footer">
								<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
								<el-button type="info" @click="getSubjectData" size="mini" :disabled="flag">确 定</el-button>
							</span>
						</el-dialog>
					</div>
					<div class="subGradeRate-table">
						<el-table border :data="subGradeRate" style="width: 100%" size="mini">
							<el-table-column prop="class" label="学科" width="70"> </el-table-column>
							<el-table-column
								sortable
								:prop="item.key"
								:label="`${item.level}等(${item.value / 100})以上`"
								v-for="(item, index) in subArr"
								:key="index"
							>
							</el-table-column>
						</el-table>
					</div>
				</div> -->
				<!-- <div class="total-grade">
					<div class="subGra-title">
						<div class="grade-title">
							<span>总分等级结构表现</span>
							<div class="Ranking-rate">
								<el-button type="" :class="RankFlag ? 'current' : ''" size="mini" @click="ImproRankClick">分数</el-button>
								<el-button type="" :class="RankFlag ? '' : 'current'" size="mini" @click="ImproRateClick">比例</el-button>
							</div>
							<el-select v-model="subject" size="mini" placeholder="请选择" @change="newChageSelect">
								<el-option v-for="item in subjectData" :key="item.pkId" :label="item.subName" :value="item.pkId"> </el-option>
							</el-select>
						</div>
					</div>
					<div class="subGradeRate-table">
						<tables :tableOptions="gradeLevelSturcture"></tables>
					</div>
				</div> -->
				<!-- <div class="subGradeRate-show">
					<div class="subGradeRate-title">
						<span>学科的平均得分率差异</span>
						<el-select v-model="subjectLevelSort" size="mini" placeholder="请选择" @change="chageSelect1">
							<el-option v-for="item in subjectLevel" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-select>
					</div>
					<div class="subGradeRate-desc">
						<p>
							从各学科的成绩表现看，每个学科的班级平均得分率最高的与最低之间的离差，从大到小的顺序是
							英语。如果联系到学科的命题难度，其相对离差从大到小的的顺序是 英语。 离差较大的学科，反映出班级水平差距较大。离差较小的学科，
							反映出该学科教学效果比较整齐。（注：语文是母语，学生水平离差来得较小应是常态）
						</p>
					</div>
					<render-Subject-Test-Perform />
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
		tables: () => import('hm-table')
	},
	data() {
		return {
			radio: 1,
			dialogVisible: false,
			flag: false,
			firstGrade: '',
			levelConts: [{ level: 'A', value: '' }],
			newSubject: '',
			subjectLevelSort: '学科离差顺序',
			levelArr: ['一等', '二等', '三等', '四等', '五等'],
			subArr: [
				{ level: 'A', value: '85', key: 'firstNum' },
				{ level: 'B', value: '75', key: 'secondNum' },
				{ level: 'C', value: '60', key: 'thirdNum' }
			],
			options: [
				{
					value: '总分',
					label: '总分'
				},
				{
					value: '语文',
					label: '语文'
				},
				{
					value: '数学',
					label: '数学'
				}
			],
			subjectLevel: [
				{
					value: '学科离差顺序',
					label: '学科离差顺序'
				},
				{
					value: '相对离差顺序',
					label: '相对离差顺序'
				}
			],
			classSubject: [
				{
					class: '2班',
					secondGearNum: '0'
				}
			],
			subGradeRate: [
				{
					class: '英语',
					firstNum: '0',
					secondNum: '0',
					thirdNum: '0',
					fourthNum: '0'
				}
			],
			totalGrade: [
				{
					class: '全体',
					firstNum: '0',
					secondNum: '0',
					thirdNum: '0',
					fourthNum: '0'
				},
				{
					class: '2班',
					firstNum: '0',
					secondNum: '0',
					thirdNum: '0',
					fourthNum: '0'
				}
			],
			tableData: [
				{
					class: '全体',
					level: '158.9',
					levelRate: '79.43%',
					level1: '79.4',
					levelRate1: '79.41%',
					level2: '79.5',
					levelRate2: '79.45%'
				},
				{
					class: '1班',
					level: '158.9',
					levelRate: '79.43%',
					level1: '79.4',
					levelRate1: '79.41%',
					level2: '79.5',
					levelRate2: '79.45%'
				},
				{
					class: '2班',
					level: '158.9',
					levelRate: '79.43%',
					level1: '81.6',
					levelRate1: '81.62%',
					level2: '79.5',
					levelRate2: '79.45%'
				},
				{
					class: '3班',
					level: '158.9',
					levelRate: '79.43%',
					level1: '81.6',
					levelRate1: '81.62%',
					level2: '79.5',
					levelRate2: '79.45%'
				},
				{
					class: '4班',
					level: '158.9',
					levelRate: '79.43%',
					level1: '81.6',
					levelRate1: '81.62%',
					level2: '79.5',
					levelRate2: '79.45%'
				},
				{
					class: '5班',
					level: '158.9',
					levelRate: '79.43%',
					level1: '81.6',
					levelRate1: '81.62%',
					level2: '79.5',
					levelRate2: '79.45%'
				}
			],
			subject: '',
			type: '2',
			RankFlag: true,
			newTableData: [],
			gradeLevelSturcture: [],
			subjectData: [],
			query: this.$route.query
		}
	},
	created() {
		this.getNewSubjectData()
		// this.getLevelStructure()
	},
	methods: {
		getNewSubjectData(subjeckId) {
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				examSubjectId: subjeckId
			}
			this.$post( 'reportApi/selectThreeRateAnalyseList', params).then(res => {
				this.newTableData = res.data.data
				this.subjectData = res.data.subjectList
				this.newSubject = res.data.examSubjectId
			})
		},
		getLevelStructure(subjeckId, type) {
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: type,
				examSubjectId: subjeckId
			}
			this.$post( 'reportApi/selectLevelReportList', params).then(res => {
				this.gradeLevelSturcture = res.data.data
				this.subjectData = res.data.subjectList
				this.subject = res.data.examSubjectId
			})
		},

		//分数
		ImproRankClick() {
			this.RankFlag = true
			this.type = '2'
			this.getLevelStructure(this.subject, this.type)
		},
		//比例
		ImproRateClick() {
			this.RankFlag = false
			this.type = '1'
			this.getLevelStructure(this.subject, this.type)
		},
		inputGrade(currentItem) {
			// 限制只能输入三位数
			currentItem.value = currentItem.value.slice(0, 3)
			// 错误判断
			this.levelConts.forEach((item, i) => {
				item.error1 = item.value !== '' && (item.value <= 0 || item.value >= 100)
				item.error2 = !item.error1 && i > 0 && Number(item.value) > Number(this.levelConts[i - 1].value)
			})
		},
		blurGrade() {
			var newFlag = this.levelConts.some(item => item.error1 === true || item.error2 === true)
			if (newFlag) {
				this.flag = true
			} else {
				this.flag = false
			}
		},
		selectLevel(value) {
			if (value == 1) {
				var firstLevel = [{ level: 'A', value: '', key: 'firstNum' }]
				this.levelConts = firstLevel
			} else if (value == 2) {
				var secondLevel = [
					{ level: 'A', value: '', key: 'firstNum' },
					{ level: 'B', value: '', key: 'secondNum' }
				]
				this.levelConts = secondLevel
			} else if (value == 3) {
				var thirdLevel = [
					{ level: 'A', value: '', key: 'firstNum' },
					{ level: 'B', value: '', key: 'secondNum' },
					{ level: 'C', value: '', key: 'thirdNum' }
				]
				this.levelConts = thirdLevel
			} else if (value == 4) {
				var fourthLevel = [
					{ level: 'A', value: '', key: 'firstNum' },
					{ level: 'B', value: '', key: 'secondNum' },
					{ level: 'C', value: '', key: 'thirdNum' },
					{ level: 'C', value: '', key: 'fourthNum' }
				]
				this.levelConts = fourthLevel
			} else if (value == 5) {
				var fifthLevel = [
					{ level: 'A', value: '' },
					{ level: 'B', value: '' },
					{ level: 'C', value: '' },
					{ level: 'D', value: '' },
					{ level: 'E', value: '' }
				]
				this.levelConts = fifthLevel
			}
		},
		getSubjectData() {
			this.dialogVisible = false
			this.subArr = this.levelConts
		},
		chageSelect(subjeckId) {
			this.getNewSubjectData(subjeckId)
		},
		newChageSelect() {
			this.getLevelStructure(this.subject, this.type)
		},
		handleClose(done) {
			done()
		}
	}
}
</script>

<style lang="less" scoped>
.current {
	background-color: #009688;
	color: #fff;
	border: 1px solid #009688;
}
.subject-test-performance {
	height: auto;
	background-color: #fff;
	margin: 10px 0px;
	padding: 30px;
	border: 1px solid #ebeef5;
	// background-color: #fff;
	color: #303133;
	-webkit-transition: 0.3s;
	transition: 0.3s;
	border-radius: 4px;
	overflow: hidden;
	&:hover {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
	.sub-test-test-cont {
		height: auto;
		.subTest-title {
			display: flex;
			align-items: center;
			margin-bottom: 10px;
			box-sizing: border-box;
			> span {
				font-weight: bold;
				font-size: 18px;
				color: #333;
				margin-right: 20px;
				flex-grow: 1;
			}
			/deep/.el-select {
				width: 100.36px;
			}
		}
		.subTest-view {
			height: auto;
			// background-color: springgreen;
			.class-level-cont {
				.class-level {
					display: flex;
					text-align: left;
					font-size: 14px;
					height: 40px;
					align-items: center;
					> div {
						// display: inline-block;
						flex-grow: 1;
						> span:nth-child(1) {
							font-size: 14px;
							color: rgb(0, 0, 0);
							margin-right: 20px;
						}
						> span:nth-child(2) {
							color: #303133;
							font-size: 12px;
						}
					}
				}
				.class-level-table {
					height: auto;
					/deep/.cell {
						text-align: center;
					}
				}
			}
		}
	}
	.class-subject-level-cont {
		height: 30px;
		margin-top: 20px;
		overflow: hidden;
		.classSubject-desc {
			height: auto;
			margin: 10px 0;
			> p:nth-child(1) {
				color: #303133;
			}
			> p:nth-child(2) {
				margin-top: 10px;
				font-size: 12px;
				color: rgb(106, 106, 106);
			}
		}
		.classSubject-btn {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			margin-bottom: 10px;
		}
		.classSubject-table {
			height: auto;
		}
	}
	.subject-grade-rate,
	.total-grade {
		height: auto;
		.subGra-title {
			display: flex;
			height: auto;
			align-items: center;
			margin-bottom: 5px;
			.grade-title {
				> span {
					font-size: 18px;
				}
				height: auto;
				margin: 5px 0;
				display: flex;
				flex-grow: 1;
				justify-content: space-between;
				align-items: center;
				font-size: 14px;
				box-sizing: border-box;
				margin-right: 10px;
				// > span {
				// 	flex-grow: 1;
				// }
				/deep/.el-button + .el-button {
					margin-left: 0;
				}
				/deep/.el-button:hover {
					color: #fff;
					background-color: #009688;
				}
			}
		}
		.setting-level {
			.level-grade {
				> span {
					position: relative;
					top: 3px;
				}
			}
			.dialog-footer {
				/deep/ .el-button:nth-child(1):hover {
					color: #909399;
					border-color: #dcdfe6;
				}
			}
			/deep/.el-dialog {
				width: 35% !important;
			}
			/deep/.el-input__inner {
				width: 152px;
			}
			/deep/.el-form-item {
				margin: 11px 0;
				margin-left: -118px;
			}
			/deep/.el-dialog__header {
				text-align: center;
			}
			/deep/.el-dialog__body {
				padding: 20px 20px;
			}
			/deep/.el-input-group {
				position: relative;
				top: 5px;
				left: -11px;
				width: 35%;
			}
			/deep/.el-form-item__label {
				width: 158px !important;
			}
			/deep/.el-form-item__content {
				margin-left: 170px !important;
				line-height: 31px;
			}
			/deep/.el-dialog__footer {
				text-align: center;
			}
			.first-p1 {
				font-size: 12px;
				color: rgb(238, 107, 82);
				margin-top: 13px;
			}
		}
	}
	.total-grade {
		height: auto;
		margin-top: 30px;
		/deep/.el-select {
			width: 100.36px;
		}
	}
	.subGradeRate-show {
		height: auto;
		margin-top: 30px;
		.subGradeRate-title {
			height: auto;
			font-size: 14px;
			display: flex;
			align-items: center;
			margin-top: 10px;
			> span {
				flex-grow: 1;
			}
		}
		.subGradeRate-desc {
			margin-top: 10px;
			margin-bottom: 20px;
			font-size: 12px;
			color: #6a6a6a;
			box-sizing: border-box;
		}
	}
}
</style>
